// extracted by mini-css-extract-plugin
export default {"loading_container":"styles_loading_container__XNWx2","loading_spinne":"styles_loading_spinne__5cOpP","spin":"styles_spin__iZXvT"};